// extracted by mini-css-extract-plugin
export var dataCell = "_pm-2";
export var dataRow = "_pm-0";
export var headerRow = "_pm-1";